import React from "react";
import {autobind} from "core-decorators";
import {Button, Popover, Typography} from "antd";
import {FaRegFileAlt} from "react-icons/fa";

import {RehearsalsQuery} from "@/graphql/types";

export interface IRehearsalsConductorsNotesProps {
  rehearsal: RehearsalsQuery["rehearsals"][0];
}

function noteIsEmpty(note?: string | null): boolean {
  return note === null || note === undefined || note.trim() === "";
}

@autobind
export default class RehearsalsConductorsNotes extends React.PureComponent<IRehearsalsConductorsNotesProps> {
  public render() {
    const {conductor_comment} = this.props.rehearsal;
    return (
      <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
        <Popover
          title="Conductor's notes"
          content={<Typography.Text>{conductor_comment}</Typography.Text>}
          trigger="click"
          arrowPointAtCenter
          placement="topLeft"
        >
          <Button type="link" shape="circle" size="small">
            {noteIsEmpty(conductor_comment) ? "-" : <FaRegFileAlt />}
          </Button>
        </Popover>
      </div>
    );
  }
}
